__webpack_require__.p = "https://gvtel.local/wp-content/themes/gvtel/pivot-blocks/service-recommender-frontend/build/";